import { render } from "./teaStudioHome.vue?vue&type=template&id=7e738ae9&scoped=true"
import script from "./teaStudioHome.vue?vue&type=script&lang=js"
export * from "./teaStudioHome.vue?vue&type=script&lang=js"

import "./teaStudioHome.vue?vue&type=style&index=0&id=7e738ae9&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e738ae9"]])

export default __exports__